import { useState } from 'react';
import styled from '@emotion/styled';
import { getTextWidth } from 'src/utils';
import { Tooltip } from 'src/components/atoms';

interface Props {
  value: string;
  width: number;
}

interface StyledCellTextProps {
  width: number;
}

const StyledCellText = styled.div<StyledCellTextProps>`
  width: ${props => `${props.width}px`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TooltipCell = ({ value, width }: Props) => {
  const [doesTextFitsInline] = useState(getTextWidth(value) < width);

  if (doesTextFitsInline) {
    return <div>{value}</div>;
  }

  return (
    <Tooltip title={value}>
      <StyledCellText width={width}>{value}</StyledCellText>
    </Tooltip>
  );
};
